/** @internal */
export const OP_BRACKET_OUT = "BracketOut";
/** @internal */
export const OP_BRIDGE = "Bridge";
/** @internal */
export const OP_CONCAT_ALL = "ConcatAll";
/** @internal */
export const OP_EMIT = "Emit";
/** @internal */
export const OP_ENSURING = "Ensuring";
/** @internal */
export const OP_FAIL = "Fail";
/** @internal */
export const OP_FOLD = "Fold";
/** @internal */
export const OP_FROM_EFFECT = "FromEffect";
/** @internal */
export const OP_PIPE_TO = "PipeTo";
/** @internal */
export const OP_PROVIDE = "Provide";
/** @internal */
export const OP_READ = "Read";
/** @internal */
export const OP_SUCCEED = "Succeed";
/** @internal */
export const OP_SUCCEED_NOW = "SucceedNow";
/** @internal */
export const OP_SUSPEND = "Suspend";
//# sourceMappingURL=channel.js.map